import { render, staticRenderFns } from "./abnormal-order.vue?vue&type=template&id=554f4b3e&"
import script from "./abnormal-order.vue?vue&type=script&lang=ts&"
export * from "./abnormal-order.vue?vue&type=script&lang=ts&"
import style0 from "./abnormal-order.vue?vue&type=style&index=0&id=554f4b3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports